export function WhatIsAppMap() {
  return (
    <section className="py-20 px-6 bg-gray-900">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-12 text-white">
          What is AppMap?
        </h2>
        
        <div className="space-y-8 text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto">
          <p>
            AppMap instruments your application to capture real-time snapshots of code execution, 
            data flow, and behavior — every time your app runs, with zero effort and no code changes.
          </p>
          
          <p>
            It brings runtime insight directly into your development environment, allowing your team 
            to review code based on how it actually behaves, not just how it looks. With{" "}
            <span className="text-pink-400 font-semibold">early bug detection</span>,{" "}
            <span className="text-pink-400 font-semibold">instant feedback</span>, and{" "}
            <span className="text-pink-400 font-semibold">faster root cause analysis</span>, 
            development teams can move faster and with greater confidence.
          </p>
          
          <p>
            Whether code is authored by a developer or generated by AI, AppMap helps your team 
            ship with{" "}
            <span className="text-pink-400 font-semibold">greater confidence</span> and{" "}
            <span className="text-pink-400 font-semibold">fewer surprises in production</span>.
          </p>
        </div>
        
        <div className="mt-12">
          <a 
            href="/get-appmap"
            className="inline-block bg-gradient-to-r from-pink-500 to-purple-600 text-white px-10 py-4 rounded-full font-semibold text-lg hover:from-pink-600 hover:to-purple-700 transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            Get AppMap
          </a>
        </div>
      </div>
    </section>
  );
}